<template>
	<div id="app">
		<div v-if="IsNoWeiXin == true">
			<div style="font-size: 10rem; text-align: center; margin-top: 5rem">
				<van-icon name="warning-o" color="gold" />
			</div>
			<div style="font-size: 2rem; text-align: center">请从微信公众号进入</div>
		</div>
		<router-view v-show='!IsNoWeiXin' />

		<van-overlay :show="OverlayShow">
			<van-loading color="#1989fa" size="30" style="text-align: center; top: 49%" />
		</van-overlay>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//判断是否从微信进入
				IsNoWeiXin: false,
				//遮罩层显示
				OverlayShow: false,
				//记录OpenID
				OpenID: "",
				//验证OpenID接口
				urlCheckOpenID: this.$utils.Url.system + "/S000/auth/checkopenid",
				LoginType: '',
			};
		},
		components: {},
		methods: {
			//验证OpenID
			CheckOpenId: function() {
				let that = this
				if (that.OpenID) {
					let params = {
						openId: that.OpenID,
					};
					console.log(params)
					//绑定用户信息
					that.$utils.HttpPost(that.urlCheckOpenID, params, function(data) {
						console.log(data)
						//获得用户对象
						let userInfoObj = data.data;
						//新增设置vuex,将当前用户写入到全局变量中
						that.$store.commit("setUserModel", userInfoObj)
						//设置Token
						let token = data.msg;
						sessionStorage.setItem("Token", token);
						that.$http.defaults.headers.common["Token"] = token;
						//跳转到首页
						setTimeout(function() {
							that.$router.push({
								name: "s400PatientList",
							});
						}, 1000)

					}, function() {
						that.$router.push({
							name: "Login",
						});
					}, null, null, null);
				}
			},
			isWeixin: function() {
				return true
				//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
				// var ua = window.navigator.userAgent.toLowerCase();
				// console.log(ua)
				// //通过正则表达式匹配ua中是否含有MicroMessenger字符串
				// if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				// 	return true;
				// } else {
				// 	return false;
				// }
			}
		},
		mounted: function() {
			let that = this
			// 设置标题
			let titleObj = document.getElementsByTagName('title')[0]
			titleObj.innerText = this.$utils.SystemName

			//获取OpenID
			that.OpenID = that.$route.query.OpenID;
			//获取用户类型
			that.LoginType = that.$route.query.type
			// 如果地址栏未传参，查看本地是否存在OpenID
			// 如果本地存在，赋值，主要防止热重载后丢失OpenID
			if (!that.OpenID && sessionStorage.getItem("OpenID")) {
				that.OpenID = sessionStorage.getItem("OpenID")
			}
			//that.OpenID = 'owtWBswHzM9iSEb9Rk8-DK-3Cg20'
			sessionStorage.setItem("OpenID", that.OpenID);
			sessionStorage.setItem("LoginType", that.LoginType);

			
			if (!this.isWeixin()) {
				that.IsNoWeiXin = true
			} else {
				var p = {
					OpenID: that.$route.query.OpenID,
					LoginType: that.$route.query.type
				}
				that.$router.push({
					name: "Login",
					params: p
				});
			}
		},
	};
</script>

<style>
	@import url("./assets/font/font.css");
	@import url("./assets/css/common.css");

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-family: "microsoft yahei";
		color: #444444;
		height: 100%;
	}

	.title {
		color: #ffffff;
		font-size: 1rem;
		text-align: center;
		background-color: #1989fa;
		margin-top: 0rem;
		margin-bottom: 0rem;
		height: 3.5rem;
		line-height: 3.5rem;
	}

	.title2 {
		color: #ffffff;
		font-size: 0.875rem;
		text-align: center;
		background-color: #0a81e5;
		margin-top: 0rem;
		margin-bottom: 0rem;
		height: 2rem;
		line-height: 2rem;
	}

	.info {
		color: #444444;
		font-size: 1rem;
		line-height: 1.5rem;
		text-align: left;
		text-indent: 2rem;
		margin: 0 auto 0 auto;
		width: 95%;
	}

	.wjtitle {
		color: #333333;
		font-size: 1rem;
		margin-left: 1rem;
	}

	.wjinfo {
		color: #444444;
		font-size: 1rem;
		line-height: 2rem;
		text-align: left;
		margin: 0 auto 0 auto;
		width: 90%;
		text-align: left;
	}
</style>

<style scoped="scoped">
</style>
